// extracted by mini-css-extract-plugin
module.exports = {"BlockQuote":"styles_BlockQuote__vTSwl","bg_1":"styles_bg_1__avBz0","bg_2":"styles_bg_2__PRSvL","img":"styles_img__TpHjD","height":"styles_height__UDGBM"};